import React, { useState } from 'react';
import { Card } from '../ui/card';
import { Sparkles, Star } from 'lucide-react';
import ServiceDetailsModal from './ServiceDetailsModal.jsx';

const services = [
  {
    id: 'basic',
    name: 'Basic Cleaning',
    price: 0.08,
    description: 'Standard maintenance cleaning',
    icon: Sparkles,
    iconStyles: {
      background: '#0d8b80',
      color: '#ffffff'
    },
    details: {
      includes: [
        'Dusting all surfaces',
        'Vacuuming carpets & rugs',
        'Mopping hard floors',
        'Cleaning bathrooms',
        'Kitchen cleaning',
        'Trash removal'
      ],
      duration: '2-4 hours',
      frequency: 'Weekly · Bi-weekly · Monthly'
    }
  },
  {
    id: 'deep',
    name: 'Deep Cleaning',
    price: 0.15,
    description: 'Detailed, intensive cleaning',
    icon: Star,
    details: {
      includes: [
        'Everything in Basic Clean',
        'Inside oven cleaning',
        'Inside fridge cleaning',
        'Baseboards & window sills',
        'Light fixtures',
        'Cabinet fronts',
        'Behind appliances'
      ],
      duration: '4-8 hours',
      frequency: 'First-time · Seasonal · Buildup'
    }
  }
];

export default function ServiceSelector({ selectedService, onServiceChange }) {
  const [activeServiceModal, setActiveServiceModal] = useState(null);

  return (
    <div className="space-y-4">
      <h2 className="section-heading selector-heading">Select Your Service</h2>

      <div className="svc-grid">
        {services.map((service) => {
          const Icon = service.icon;
          const isSelected = selectedService === service.id;

          return (
            <Card
              key={service.id}
              className={`svc-card ${isSelected ? 'selected' : ''}`}
              onClick={() => onServiceChange(service.id)}
            >
              <div
                className="svc-card-content p-4 cursor-pointer text-center"
              >
                <div className="svc-icon-badge mx-auto mb-3" style={service.iconStyles}>
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="svc-title">{service.name}</h3>
                <p className="svc-desc">{service.description}</p>
                <p className="svc-rate">${service.price.toFixed(2)} / sq ft</p>
                <p className="svc-best">
                  <span className="svc-best-label">Best for:</span> {service.details.frequency}
                </p>
              </div>

              <div className="svc-actions">
                <button
                  type="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    setActiveServiceModal(service.id);
                  }}
                  className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 btn-ghost"
                >
                  Know more
                </button>
                {isSelected && <span className="svc-chip">Selected</span>}
              </div>
            </Card>
          );
        })}
      </div>

      <ServiceDetailsModal
        serviceId={activeServiceModal}
        onClose={() => setActiveServiceModal(null)}
      />
    </div>
  );
}
